import { useTranslations } from "use-intl";
import type { EnglishMessages } from "@financialharmony/i18n/messageTypes";
import { getStatusBadge } from "@/utils/paymentUtils";
import type { StatusBadge } from "@/types/payments";
import { hasMessageKey } from "./hasMessageKey";

type BadgeKey = keyof EnglishMessages["consultantPayables"]["badge"];

/** `getStatusBadge` with the label in the language the app shows; its variants are unchanged. */
export function useStatusBadge() {
  const t = useTranslations("consultantPayables.badge");
  return (status: Parameters<typeof getStatusBadge>[0]): StatusBadge => {
    const badge = getStatusBadge(status);
    return badge && hasMessageKey<BadgeKey>(t, status) ? { ...badge, label: t(status) } : badge;
  };
}
